import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_left",
  "use": "chevron_left-usage",
  "viewBox": "0 0 7 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 13\" id=\"chevron_left\"><path d=\"m6.095 11.927-1.124.836-4.53-6.09L4.97.583l1.125.834L2.183 6.67\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol